var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CardBodyItem",
    {
      staticClass: "w-full text-primary-500",
      attrs: { label: _vm.label, labelClass: "mr-2" },
    },
    [
      _c(
        "RouterLink",
        {
          staticClass:
            "hover:text-primary-800 hover:underline truncate text-sm",
          attrs: {
            to: {
              name: _vm.routeName,
              params: _vm.routeParams,
              query: _vm.routeQuery,
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.value) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }